module.exports = __webpack_public_path__ + "static/019-85bf848d316373eaefed3685c7d05718.jpg";